<template>
  <div class="tabla-productos-wrapper">
    <b-table :data="listaProductos" hoverable class="productos-table">
      <b-table-column field="codigo" label="Código" v-slot="props" width="100">
        <span class="mono-text">{{ props.row.codigo }}</span>
      </b-table-column>

      <b-table-column field="nombre" label="Producto" v-slot="props">
        <span class="producto-nombre">{{ props.row.nombre }}</span>
      </b-table-column>

      <b-table-column field="precio" label="Precio" v-slot="props" width="160">
        <span v-if="props.row.mayoreoAplicado" class="mayoreo-precio">
          <b-icon icon="tag" size="is-small" />
          ${{ formatoMonto(props.row.precio) }}
        </span>
        <b-select
          v-if="!props.row.mayoreoAplicado"
          class="wide precio-select"
          v-model="props.row.precio"
          @input="$emit('precioCambiado')"
          size="is-small"
        >
          <option
            v-for="precio in precios(props.row)"
            :key="precio"
            :value="precio"
          >
            ${{ formatoMonto(precio) }}
          </option>
        </b-select>
      </b-table-column>

      <b-table-column
        field="cantidad"
        label="Cantidad"
        v-slot="props"
        width="220"
      >
        <div class="cantidad-row">
          <b-numberinput
            @input="aumentar(props.row)"
            min="0.1"
            step="0.01"
            :max="props.row.existencia"
            v-model="props.row.cantidad"
            size="is-small"
            controls-position="compact"
            class="cantidad-input pt-5"
          />
          <span class="unidad-badge">{{
            unidades[props.row.unidad].toLowerCase()
          }}</span>
        </div>
      </b-table-column>

      <b-table-column
        field="subtotal"
        label="Subtotal"
        v-slot="props"
        width="110"
      >
        <!-- BUG FIX: formatoMonto() devuelve string; .toFixed() no existe en strings.
             Calculamos el valor numérico primero, luego llamamos formatoMonto -->
        <span class="subtotal-valor">
          ${{ formatoMonto(props.row.precio * props.row.cantidad) }}
        </span>
      </b-table-column>

      <b-table-column label="" v-slot="props" width="52" centered>
        <b-button
          icon-left="delete"
          type="is-danger"
          size="is-small"
          rounded
          @click="quitar(props.row.id)"
        />
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { UNIDADES } from "@/consts";
import Utiles from "../../Servicios/Utiles";

export default {
  name: "TablaProductos",
  props: ["listaProductos"],

  data: () => ({
    unidades: UNIDADES,
  }),

  methods: {
    quitar(id) {
      this.$emit("quitar", id);
    },

    aumentar(producto) {
      this.$emit("aumentar", producto);
    },

    precios(producto) {
      const {
        precioVenta,
        precioVenta2,
        precioVenta3,
        precioVenta4,
        precioVenta5,
        precioVenta6,
        precioVenta7,
      } = producto;
      return [
        precioVenta,
        precioVenta2,
        precioVenta3,
        precioVenta4,
        precioVenta5,
        precioVenta6,
        precioVenta7,
      ].filter((precio) => !!Number(precio));
    },

    formatoMonto(valor) {
      return Utiles.formatoMonto(valor);
    },
  },
};
</script>

<style scoped>
.tabla-productos-wrapper {
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 1px solid var(--color-border);
}
.mono-text {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--color-text-muted);
}
.producto-nombre {
  font-weight: 500;
  font-size: 0.84rem;
}
.mayoreo-precio {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: var(--color-accent);
  font-size: 0.84rem;
}
.cantidad-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.cantidad-input {
  width: 120px;
}
.unidad-badge {
  font-size: 0.72rem;
  color: var(--color-text-dim);
  white-space: nowrap;
}
.subtotal-valor {
  font-weight: 700;
  font-family: var(--font-mono);
  font-size: 0.88rem;
  color: var(--color-primary);
}
</style>
